import { WordAttribute, WordAttributeWithOption } from 'types/ReduxStateTypes';

const filterWordAttributes = (
  wordAttributes: WordAttributeWithOption[],
  filterSchema: WordAttribute[]
) => wordAttributes.filter(w => !filterSchema.includes(w.value));

export default filterWordAttributes;
